module.exports = __webpack_public_path__ + "static/img/jiaJu.8d622992.jpg";